module.exports = __webpack_public_path__ + "img/chack.41890cc2.png";